export default __webpack_public_path__ + "static/media/car.67ea398c.png";